import React from 'react';
import { motion } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';
import './GuideModal.css';

const MacGuide = ({ onClose }) => {
  const steps = [
    {
      id: 1,
      title: 'STEP 1',
      description: '下载 DMG 文件',
      tip: '双击打开 DMG 文件'
    },
    {
      id: 2,
      title: 'STEP 2',
      description: '拖动到应用程序文件夹',
      tip: '将应用图标拖到 Applications 文件夹'
    },
    {
      id: 3,
      title: 'STEP 3',
      description: '打开系统设置',
      tip: '进入 系统设置 > 隐私与安全性'
    },
    {
      id: 4,
      title: 'STEP 4',
      description: '允许任意来源软件',
      tip: '点击"仍要打开"按钮'
    }
  ];

  return (
    <motion.div
      className="guide-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
    >
      <motion.div
        className="guide-modal"
        initial={{ scale: 0.9, opacity: 0, y: 20 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0.9, opacity: 0, y: 20 }}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="close-btn" onClick={onClose}>
          <FaTimes />
        </button>

        <div className="modal-header">
          <h2>macOS 安装指南</h2>
          <p>请按照以下步骤完成安装</p>
        </div>

        <div className="steps-grid">
          {steps.map((step, index) => (
            <motion.div
              key={step.id}
              className="step-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <div className="step-number-badge">{step.id}</div>
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
                <p className="step-tip">{step.tip}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.button
          className="action-btn"
          onClick={onClose}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          我知道了
        </motion.button>
      </motion.div>
    </motion.div>
  );
};

export default MacGuide;

